export const addBusinessDays = (date: Date, daysNumber: number) => {
    var result = new Date(date);
    result.setDate(result.getDate() + daysNumber);
    return result
};